module.exports = __webpack_public_path__ + "img/news.bfd4b9fe.svg";